
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../node_modules/vue-loader/lib/style-rewriter?id=data-v-5698f75c!less-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./vue-event-calendar.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./vue-event-calendar.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-5698f75c!../node_modules/vue-loader/lib/selector?type=template&index=0!./vue-event-calendar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/vue-event-calendar.vue
// module id = 3
// module chunks = 0